//Document ready
$(function() {
	initFilterCheckbox();
	resetFilterCheckbox();
});

//Init filter checkbox
function initFilterCheckbox() {
	var filterInputs = document.querySelectorAll(".filter-input input"),
		i;

	for (i = 0; i < filterInputs.length; ++i) {
		filterInputs[i].addEventListener(
			"change",
			function() {
				filterInputChange(this);
			},
			false
		);
	}
}

function filterInputChange(item) {
	var relevantInputs = item.parentNode.parentNode.querySelectorAll(".filter-input input");

	for (i = 0; i < relevantInputs.length; ++i) {
		if (relevantInputs[i] != item) {
			relevantInputs[i].checked = false;
		}
	}
}

//Reset filter checkbox
function resetFilterCheckbox() {
	var filterResets = document.querySelectorAll(".filter-reset"),
		i;

	for (i = 0; i < filterResets.length; ++i) {
		filterResets[i].addEventListener("click", function() {
			var filterID = this.getAttribute("data-filter-id");
			var relevantInputs = document.querySelectorAll("#" + filterID + " .filter-input input");
			for (i = 0; i < relevantInputs.length; ++i) {
				relevantInputs[i].checked = false;
			}
		});
	}
}
